import { createAction, props } from '@ngrx/store';
import { Attachment } from 'app/models/api/attachment';

export enum AttachmentsActionTypes {
  LoadAttachments = '[Attachments] LoadAttachments',
  LoadAttachmentsSuccess = '[Attachments] LoadAttachmentsSuccess',
  AddAttachment = '[Attachments] AddAttachment',
  UpdateAttachment = '[Attachments] UpdateAttachment',
  DeleteAttachment = '[Attachments] DeleteAttachment',
  AttachmentActionFail = '[Attachments] AttachmentActionFail',
  OrderAttachmentsBy = '[Attachments] OrderAttachmentsBy'
}

export const loadAttachments = createAction(AttachmentsActionTypes.LoadAttachments);
export const loadAttachmentsSuccess = createAction(AttachmentsActionTypes.LoadAttachmentsSuccess, props<{ attachments: Attachment[] }>());
export const attachmentActionFail = createAction(AttachmentsActionTypes.AttachmentActionFail, props<{ error: unknown }>());
export const addAttachment = createAction(AttachmentsActionTypes.AddAttachment, props<{ attachment: Attachment }>());
export const updateAttachment = createAction(AttachmentsActionTypes.UpdateAttachment, props<{ attachments: Attachment[] }>());
export const deleteAttachment = createAction(AttachmentsActionTypes.DeleteAttachment, props<{ attachmentIds: string[] }>());
export const orderAttachmentsBy = createAction(AttachmentsActionTypes.OrderAttachmentsBy, props<{ key: string }>());
